import { openMetadataApiClient } from '@/shared/api/core/axios-instance';
import type { JsonPatchOperation } from '@/shared/types/common';
import type { DomainTreeItem } from '@/shared/types/domain';

import type { DomainHierarchyItem } from '@/entities/domain';
import { findDomainInHierarchy } from '@/entities/domain/lib';

type DomainValue = {
  id: string;
  type: string;
  name: string;
  fullyQualifiedName: string;
  displayName: string;
  description: string;
};

export const updateEntityDomains = async (
  endpoint: string,
  selectedDomainId: string | null,
  hierarchy: DomainHierarchyItem[],
  currentDomains: DomainTreeItem[]
): Promise<void> => {
  const operations: JsonPatchOperation[] = [];

  if (currentDomains.length > 0) {
    operations.push({
      op: 'remove',
      path: '/domains/0',
    });
  }

  if (selectedDomainId) {
    const domainItem = findDomainInHierarchy(hierarchy, selectedDomainId);
    if (domainItem) {
      const newDomain: DomainValue = {
        id: domainItem.id,
        type: 'domain',
        name: domainItem.name,
        fullyQualifiedName: domainItem.fullyQualifiedName,
        displayName: domainItem.displayName,
        description: domainItem.description,
      };

      operations.push({
        op: 'add',
        path: '/domains',
        value: [newDomain],
      });
    }
  }

  if (operations.length > 0) {
    await openMetadataApiClient.patch(endpoint, operations, {
      headers: {
        'Content-Type': 'application/json-patch+json',
      },
    });
  }
};
